import React from "react";
import { Modal } from "react-bootstrap";
import LobOrderSuccessIcon from "@frameworks/shared-library/assets/images/features/Markets/Pms/lob-order-success.svg";
var OrderSuccess = function (_a) {
    var setShow = _a.setShow, show = _a.show, onClickCancel = _a.onClickCancel, type = _a.type, _b = _a.title, title = _b === void 0 ? "" : _b;
    return (React.createElement(Modal, { show: show, setShow: setShow, backdrop: true, centered: true, contentClassName: "custom-modal-content", className: "order-modal" },
        React.createElement("span", { className: "close-container", onClick: onClickCancel },
            React.createElement("i", { className: "edel-icon-close" })),
        React.createElement("img", { src: LobOrderSuccessIcon, alt: "success-image", className: "success-image" }),
        React.createElement("div", { className: "d-flex flex-column gap-2" },
            React.createElement("p", { className: "title" }, title),
            React.createElement("p", { className: "subtitle" },
                "All the selected orders have been successfully",
                " ",
                type == "approve" ? "approved" : "rejected",
                "."))));
};
export default OrderSuccess;
